import { loadStripe } from '@stripe/stripe-js'

export const useStripe = () => {
	interface CheckoutBody {
		mode: string
		customer_creation: string
		line_items: { price: string, quantity: number }[]
		return_url: string
		custom_fields?: { key: string, label: { type: string, custom: string }, type: string }[]
		user?: string
		customer_email?: string
	}

	const stripeInstance = useState<any>('stripeInstance', () => null)

	const unmountCheckout = async () => {
		await stripeInstance.value?.embeddedCheckout.destroy()
		stripeInstance.value = null
	}

	const checkoutPortal = async (product: any, type: 'sub' | 'pass') => {
		const { $singaApi } = useNuxtApp()
		const userStore = useUserStore()
		const { user } = userStore
		const config = useRuntimeConfig()
		const stripe = await loadStripe(config.public.stripePublicKey as string)
		if (stripeInstance.value) {
			await unmountCheckout()
			stripeInstance.value = null
		}

		const mode = type === 'sub' && !product.is_gift ? 'subscription' : 'payment'
		const id = type === 'sub' ? product.stripe_id : product.id
		const body: CheckoutBody = {
			mode: mode,
			customer_creation: 'always',
			line_items: [{ price: id, quantity: 1 }],
			return_url: window.location.href,
			user: user?.stripe_customer_id,
			customer_email: user?.email
		}

		if (product.is_gift) {
			body.custom_fields = [
				{
					key: 'Recipient_name',
					label: { type: 'custom', custom: 'Recipient\'s name' },
					type: 'text'
				}
			]
		}

		try {
			const fetchClientSecret = async () => {
				const response = await $singaApi.Me.Stripe.checkoutSession(body)
				return response
			}
			stripeInstance.value = await stripe?.initEmbeddedCheckout({
				fetchClientSecret
			})

			stripeInstance.value?.mount('#checkout')
			return stripeInstance.value
		} catch (error) {
			console.error(error)
			return null
		}
	}

	return {
		checkoutPortal,
		unmountCheckout
	}
}
